<template>
  <div class="xcard">
    <div id="appq"></div>
  </div>
</template>

<script>
export default {
  mounted(){
    //const domain = 'localhost:8081';
    const domain = 'meet.jit.si';
      const options = {
          roomName: 'saldias94',
          width: 700,
          height: 480,
          parentNode: document.querySelector('#appq')
      };
      /*const api = */new window.JitsiMeetExternalAPI(domain, options);
      //api.dispose();
  },
}
</script>